<template>
  <v-main style="padding-bottom: 18px">
    <UnverifiedAlert v-if="showAlert" @closeUnverified="closeAlert = true" />
    <transition name="slide-x-transition" mode="out-in">
      <router-view />
    </transition>
  </v-main>
</template>

<script>
import UnverifiedAlert from "@/components/UnverifiedAlert.vue";
import { mapActions, mapGetters } from "vuex";
import store from '@/store';
import UM from "@/api/user-management";


export default {
  components: { UnverifiedAlert },
  name: "TheLayoutContent",
  data: () => ({
    closeAlert: false,
    routesOfNotShowAlert: [
      "UserInfo",
      "registerSteps",
      "ValidationEmail",
      "resetPassword"
    ],
    isEmailVerify: true
  }),
  computed: {
    ...mapGetters({
      access_token: 'user/access_token',
      verifyEmail: 'user/verifyEmail'
    }),
    showAlert() {
      if (this.routesOfNotShowAlert.find(value => value === this.$route.name)) 
        return false;
      if (this.closeAlert) return false;
      if (!!this.access_token) return !this.isEmailVerify;
    }
  },
  watch: {
    verifyEmail(newVal, oldVal) {
      this.isEmailVerify = newVal;
      this.closeAlert = newVal;
    },
    async $route(to, from) {
      this.closeAlert = false;
      if (this.access_token) this.getVerifyEmailStatus();
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.access_token) this.getVerifyEmailStatus();
    }, 500);
  },
  methods: {
    ...mapActions({
      setVerifyEmailStatus: "user/setVerifyStatus"
    }),
    async getVerifyEmailStatus() {
      // const { data: maskedUseerInfoRes } = await UM.getMaskedUserInfo();
      // console.log(
      //   `${String.fromCodePoint(128049)} [UM] getMaskedUserInfo`,
      //   maskedUseerInfoRes
      // );
      // this.setVerifyEmailStatus(maskedUseerInfoRes.userInfo?.verifyEmail);

      if(!Cookies.get('user') && !!store.state.user && !!store.state.user.account) {
        Cookies.set('user', JSON.stringify({...store.state.user}), { expires: 90 })
        Cookies.set('expiredTime', JSON.stringify(0), { expires: 90 })
      }
      const user = JSON.parse(Cookies.get('user'));
      this.isEmailVerify = this.verifyEmail;
    }
  }
};
</script>
